import { useCti as HubSpotCTI } from "./hubspot";
import { useCti as FreshworksCTI } from "./freshworks";
import { useCti as PipeDriveCTI } from "./pipedrive";
import { useCti as ZendeskCTI } from "./zendesk";
import { useCti as ZohoCTI } from "./zoho";
import { useCti as HookCTI } from "./hook";
export default class UseHook {
    constructor(events = {}) {
        if (!UseHook.cti) {
            UseHook.cti = UseHook.useCti(events);
        }
        return UseHook.cti;
    }
    static useCti(events = {}) {
        const type = process.env.APP_PROJECT_TYPE;
        if (!type) {
            return HookCTI(events);
        }
        let cti;
        switch (type.toLowerCase()) {
            case 'hubspot':
                cti = HubSpotCTI();
                break;
            case 'freshworks':
                cti = FreshworksCTI();
                break;
            case 'pipedrive':
                cti = PipeDriveCTI();
                break;
            case 'zendesk':
                cti = ZendeskCTI();
                break;
            case 'zoho':
                cti = ZohoCTI();
                break;
            default:
                cti = HookCTI(events);
                break;
        }
        return cti;
    }
}
